/**
 * @file   式样
 * @create macaiqi 2025/07/25
 * @update 
 */
import React, { useEffect, useState } from 'react';
import cls from 'classnames'
import { queryArchivesList, queryArchivesById } from '../../service';
import './shiyang.scss'
import { htmltoStr } from '../../utils';

export default function ShiYang({ setShow, showqin, setShowQin, floorAt }) {
    const [tabactive, setTabActive] = useState();
    const [listdata, setListData] = useState([])
    const [data, setData] = useState()


    useEffect(() => {
        queryArchivesList({
            resource: floorAt === 1 ? 'SYOne' : "SYTwo",
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setListData(res?.records || [])

            let idnow = res?.records?.filter((a) => { return a.title === showqin })?.[0]?.id
            setTabActive(idnow)
        })
    }, [floorAt, showqin])

    useEffect(() => {
        if (tabactive) {
            queryArchivesById(tabactive).then(res => {
                setData(res)
            })
        }
    }, [tabactive])
    return (
        <div className="common-page shiyang-page">
            <div className="page-l">
                <i />
                <div className="titleall">
                    <div className="bigtxt" />
                </div>

                <div
                    className="back"
                    onClick={() => {
                        setShow("");
                        setShowQin()
                    }}></div>
            </div>

            <div className="tablist">
                {
                    listdata?.map((item, index) => {
                        return (
                            <div
                                className={cls("tab", { active: tabactive === item.id })}
                                key={index}
                                onClick={() => {
                                    setTabActive(item.id);
                                }}
                            >{item.title}</div>
                        );
                    })}
            </div>
            <div className={cls("content", `commoncontent qrqqcontent`)}>
                <div className="scroll">
                    <div className="img">
                        <img src={window.ENV_IMG_PREURL + data?.imgSrc} alt="" srcset="" />
                    </div>
                    <div className="content-r">
                        {data?.abstract && <div className="r-top">
                            {htmltoStr(data?.abstract)}
                        </div>}
                        <div className="r-bottom" dangerouslySetInnerHTML={{ "__html": data?.content }} />
                    </div>
                </div>
            </div>
        </div >
    )
}
